module.exports = __webpack_public_path__ + "fonts/BerkeleyMono-Regular.8340d1c.woff2";